(() => {
  function initVideoBanner(sectionEl) {
    if (!sectionEl) return;

    // Future-safe hook
    sectionEl.setAttribute('data-vnb-initialized', 'true');
  }

  function runAll(root = document) {
    root.querySelectorAll('.vnb').forEach(initVideoBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => runAll(), { once: true });
  } else {
    runAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.('.vnb') || event.target;
    if (section instanceof HTMLElement) initVideoBanner(section);
  });

  document.addEventListener('shopify:section:select', (event) => {
    const section = event.target?.querySelector?.('.vnb') || event.target;
    if (section instanceof HTMLElement) initVideoBanner(section);
  });

  document.addEventListener('shopify:section:reorder', () => {
    runAll();
  });
})();